import React from 'react';
import {
    Box, Typography, TextField, Button, Card, CardContent, IconButton, Divider,
    ThemeProvider, createTheme, styled
} from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate } from 'react-router-dom';

const theme = createTheme({
    palette: {
        primary: {
            main: '#3488A4',
        },
    },
});

const StyledCard = styled(Card)(({ theme }) => ({
    boxShadow: 'none',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    marginBottom: '16px',
}));

const SummaryItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '8px',
    padding: '12px',
    '&:hover': {
        backgroundColor: theme.palette.primary.dark,
    },
}));

const CartSummary = ({ onClose, calculations, userBalance, cartData, couponCode, setCouponCode, handleApplyCoupon, HandlePlaceOrder,
    deliveryAddress, deliveryMethod, priorityTip, setShowCheckout, setShowOrders, setShowProfile, setProduct_Details, handleCategoryClick
}) => {
    const navigate = useNavigate();
    return (
        <ThemeProvider theme={theme}>
            <StyledCard>
                <CardContent>
                    {/* <Typography variant="h6" gutterBottom>Promo Code</Typography>
                    <Box sx={{ display: 'flex', mb: 2 }}>
                        <TextField
                            fullWidth
                            placeholder="Promo Code"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                            variant="outlined"
                            size="small"
                            InputProps={{
                                startAdornment: <LocalOfferIcon color="action" sx={{ mr: 1, color: theme.palette.primary.main }} />,
                            }}
                        />
                        <StyledButton onClick={handleApplyCoupon} sx={{ ml: 1, px: 3 }}>
                            Apply
                        </StyledButton>
                    </Box> */}


                    {/* <Typography variant="h6" gutterBottom>Branch</Typography>
                    <SummaryItem>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <StorefrontIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                            <Typography>{cartData?.[0]?.business_details.name}</Typography>
                        </Box>
                    </SummaryItem> */}


                    {/* <SummaryItem>
                        <Typography>Subtotal</Typography>
                        <Typography>{parseFloat(calculations?.subTotal).toFixed(2)}</Typography>
                    </SummaryItem> */}
                    {/* <SummaryItem>
                        <Typography>Discount</Typography>
                        <Typography>-{parseFloat(calculations?.discount).toFixed(2)}</Typography>
                    </SummaryItem> */}
                    {calculations?.sst_percentage !== '0%' && (
                        <SummaryItem>
                            <Typography>
                                {calculations?.sst_dynamic_label
                                    ? `${calculations?.sst_dynamic_label} (${calculations?.sst_percentage})`
                                    : ''}
                            </Typography>

                            {calculations?.sst > 0 && (
                                <Typography>{parseFloat(calculations?.sst).toFixed(2)}</Typography>
                            )}
                        </SummaryItem>
                    )}

                    {/* <SummaryItem>
                        <Typography>Delivery Charges</Typography>
                        <Typography>{parseFloat(calculations?.deliveryTipFee).toFixed(2)}</Typography>
                    </SummaryItem> */}

                    <SummaryItem sx={{ mt: 2, mb: 3 }}>
                        <Typography variant="h6">GRAND TOTAL</Typography>
                        <Typography variant="h6" color="primary">RM{parseFloat(calculations?.grandTotal).toFixed(2)}</Typography>
                    </SummaryItem>

                    {/* <Box sx={{ bgcolor: '#e8f5e9', p: 2, borderRadius: 2, mb: 2, display: 'flex', alignItems: 'center' }}>
                        <CardGiftcardIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                        <Typography variant="body2">
                            You will get {calculations?.order_reward_points} reward points with this order
                        </Typography>
                    </Box> */}
                    <Divider sx={{ my: 2 }} />
                    {/* <Typography variant="h6" gutterBottom>Payment Method</Typography>
                    <SummaryItem>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <AccountBalanceWalletIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                            <Typography>Current Balance</Typography>
                        </Box>
                        <Typography>{userBalance?.total_balance ? parseFloat(userBalance.total_balance).toFixed(2) : '0.00'}</Typography>
                    </SummaryItem> */}


                    <Box sx={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        p: 2,
                        backgroundColor: 'white',
                        borderTop: '1px solid #E5E7EB',
                    }}>
                        <Button
                            fullWidth
                            variant="outlined"
                            sx={{
                                mb: 1,
                                height: '48px',
                                borderRadius: '8px',
                                color: '#3488A4',
                                backgroundColor: '#E3F2FD',
                                border: 'none',
                                '&:hover': {
                                    backgroundColor: '#BBDEFB',
                                    border: 'none',
                                }
                            }}
                            onClick={() => {
                                setShowOrders(false);
                                setShowProfile(false);
                                setProduct_Details(null);
                                handleCategoryClick(null);
                                onClose()
                            }}                        >
                            Continue Shopping
                        </Button>
                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                height: '48px',
                                borderRadius: '8px',
                                backgroundColor: '#3488A4',
                                '&:hover': {
                                    backgroundColor: '#2C7A96'
                                }
                            }}
                            // onClick={() => HandlePlaceOrder(cartData, deliveryMethod, deliveryAddress, priorityTip, couponCode, calculations.grandTotal)}
                            onClick={() => {
                                setShowOrders(false);
                                setShowProfile(false);
                                setProduct_Details(null);
                                handleCategoryClick(null);
                                setShowCheckout(true)
                                onClose();
                            }}

                        >
                            Check Out (RM{parseFloat(calculations?.grandTotal).toFixed(2)})
                        </Button>
                    </Box>
                    {/* <StyledButton
                        fullWidth
                        size="large"
                        startIcon={<ShoppingCartIcon />}
                        onClick={() => HandlePlaceOrder(cartData, deliveryMethod, deliveryAddress, priorityTip, couponCode, calculations.grandTotal)}
                    >
                        PLACE ORDER {parseFloat(calculations?.grandTotal).toFixed(2)}
                    </StyledButton> */}
                </CardContent>
            </StyledCard>
        </ThemeProvider>
    );
};

export default CartSummary;